import { Typography } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, getColumnValue, numberColumn, textColumn, timeColumn, yesNoColumn } from "./columnHelpers";
import { EventDate } from "@components/EventDate";

export const datesRelationship = {
    collapsible: true,
    title: 'Dates',
    tint: 'default',
    type: 'table',
    sort: ['start_date'],
    columns: [
        genericColumn({
            label: 'Date',
            render: {
                show: (object) => {
                    return <EventDate date={object}/>;
                },
            },
        }),
        genericColumn({
            label: 'Location',
            render: {
                show: (object, parentObject) => {
                    return object.location ? object.location : parentObject.location;
                },
            },
        }),
    ],
};

export const datesRelationshipEdit = {
    collapsible: true,
    title: 'Dates',
    tint: 'default',
    type: 'table',
    sort: ['start_date'],
    columns: [
        dateColumn({
            label: 'Start Date',
            column: 'start_date',
        }),
        timeColumn({
            label: 'Start Time',
            column: 'start_time',
        }),
        dateColumn({
            label: 'End Date',
            column: 'end_date',
        }),
        timeColumn({
            label: 'End Time',
            column: 'end_time',
        }),
        textColumn({
            label: 'Location',
            column: 'location',
        }),
    ],
};
